import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'appraisalUploadStatus',
    label: 'UCCP Appraisal Upload Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dataTransmittalDate',
    label: 'Appraisal Data Transmittal Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'appraisalDocumentId',
    label: 'Appraisal Document Identifier',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'roomsNumber',
    label: 'Number of Rooms',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bedroomsNumber',
    label: 'Number of Bedrooms',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bathsNumber',
    label: 'Number of Baths',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'rent',
    label: 'Rent',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'locationType',
    label: 'Location Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lot',
    label: 'Lot',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyAcreage',
    label: 'Property Acreage',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'block',
    label: 'Block',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'plat',
    label: 'Plat',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lotAcquiredDate',
    label: 'Lot Acquired Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'originalLotCost',
    label: 'Original Cost of Lot',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'surveyDate',
    label: 'Survey Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lotAppraisedValue',
    label: 'Lot Appraised Value',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'numberOfStories',
    label: 'Number of Stories',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertySquareFootage',
    label: 'Property Square Footage',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'censusTract', label: 'Census Tract', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'assessorParcelNumber',
    label: 'Assessor’s Parcel Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'yearBuilt', label: 'Year Built', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'appraisalManagementCompanyName',
    label: 'Appraisal Management Company',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'appraiserName',
    label: 'Appraiser Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'appraiserLicenseNumber',
    label: 'Appraiser License #',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'appraisalCompanyName',
    label: 'Appraisal Company',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'supervisoryAppraiserName',
    label: 'Supervisory Appraiser',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const appraisalForm = {
  name: FormNames.APPRAISAL,
  label: 'Appraisal',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
